import { IEmployeeNode } from '../../../common/model/graphql-types';
import { IEmployee } from '../model/Employee.model';

export const ConvertToEmployeeModel = (data: IEmployeeNode): IEmployee => {
  return {
    id: data.id,
    slug: data.slug,
    fullName: data.fullName,
    shortName: data.shortName,
    role: data.role,
    showNewTag: data.showNewTag,
    hasBeenBuffedRecently: data.hasBeenBuffedRecently,
    isPartOfTerrorDeck: data.isPartOfTerrorDeck,
    rarityClassName: data.rarityClassName,
    smallAvatar: data.smallAvatar
      ? data.smallAvatar.localFile.childImageSharp
      : null,
    type: data.type,
    isRatingPending: data.isRatingPending,
    seaReleaseDate: data.seaReleaseDate,
    globalReleaseDate: data.globalReleaseDate,
    cost: data.cost,
    newRatings: {
      pvp_sea: data.newRatings.pvp_sea,
      pvp_global: data.newRatings.pvp_global,
      pve_early: data.newRatings.pve_early,
      pve_late: data.newRatings.pve_late
    },
    isRearmed: data.isRearmed,
    hasAlternium: data.hasAlternium,
    movementType: data.movementType,
    attackType: data.attackType,
    reviewGeneral: data.reviewGeneral,
    pros: data.pros,
    cons: data.cons,
    gearRecommendation: data.gearRecommendation
  } as IEmployee;
};
